export default __webpack_public_path__ + "static/s12-666ff8e9269f27d0526083408366bad5.png";